import { render } from "./LegacyIcon.vue?vue&type=template&id=607228ab"
import script from "./LegacyIcon.vue?vue&type=script&lang=js"
export * from "./LegacyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__